import axios from "axios";
import qs from "qs";

export const apiClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL
});

export default {
  login(user) {
    return apiClient.post("/login", user);
  },
  logout(user) {
    return apiClient.post("/logout", user);
  },
  get(payload) {
    return apiClient.get(payload.url, { params: payload.params });
  },
  // getAll(payload) {
  //   return apiClient.get(payload.url);
  // },
  post(payload) {
    return apiClient.post(payload.url, qs.stringify(payload.data));
  },
  put(payload) {
    return apiClient.put(payload.url, qs.stringify(payload.data));
  },
  delete(payload) {
    return apiClient.delete(payload.url);
  },
  getFile(payload) {
    return apiClient.get(payload.url, {
      params:payload.data,
      responseType: "arraybuffer",
      headers: { Authorization: 'Bearer ' + localStorage.getItem("token") }
    });
  },
  // getPdf(payload) {
  //   return apiClient.get(payload.url, {
  //     responseType: "arraybuffer"
  //   });
  // },
  getDocumento(data) {
    return apiClient.post(data.url, qs.stringify(data.data), {
      responseType: "arraybuffer",
    });
  },
  getAcuse(data) {
    return apiClient.get(data.url, {
      responseType: "arraybuffer",
      params: data.data
    });
  },
};
